module.exports = __webpack_public_path__ + "static/media/fa-light-300.84c28724.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/fa-light-300.woff2
// module id = 767
// module chunks = 0